import React, { useRef, useCallback } from 'react';
import Camera from 'react-camera-ios';
import styles from './Media.module.scss';

interface IOSCameraMediaProps {
    videoActive: boolean;
    onVideoError?: (error: Error) => void;
    onVideoReady?: (stream: MediaStream) => void;
}

export const IOSCameraMedia: React.FC<IOSCameraMediaProps> = ({
    videoActive,
    onVideoError,
    onVideoReady
}) => {
    const cameraRef = useRef<Camera>(null);

    const handleCameraError = useCallback((error: Error) => {
        console.error('📹 iOS Camera error:', error);
        if (onVideoError) {
            onVideoError(error);
        }
    }, [onVideoError]);

    // Добавляем отладочную информацию для react-camera-ios
    React.useEffect(() => {
        if (cameraRef.current && videoActive) {
            console.log('📹 react-camera-ios component mounted and active');
        }
    }, [videoActive]);

    return (
        <div className={styles.mediaContainer} style={{ display: 'none' }}>
            <h4>Ваше видео</h4>
            <div className={styles.videoGrid}>
                {videoActive ? (
                    <Camera
                        ref={cameraRef}
                        device="mobile"
                        facingMode="user"
                        isTurnedOn={videoActive}
                        placement="contain"
                        onError={handleCameraError}
                        className={styles.videoElement}
                        style={{
                            width: '100%',
                            aspectRatio: '9/16',
                            objectFit: 'cover'
                        }}
                    />
                ) : null}
            </div>
        </div>
    );
};
